module.exports = __webpack_public_path__ + "static/img/OM.d49c87eb.svg";